const LINE_1 = [
  { name: "Figma", type: "Tools", prof: "2" },
  { name: "JavaScript", type: "Language", prof: "3" },
  { name: "Express", type: "Backend", prof: "3" },
  { name: "ReactJS", type: "Frontend", prof: "1" },
];

const LINE_2 = [
  { name: "Node.js", type: "Backend", prof: "2" },
  { name: "HTML", type: "Frontend", prof: "3" },
  { name: "GItHub", type: "Tools", prof: "3" },
  { name: "TypeScript", type: "Language", prof: "2" },
];

const LINE_3 = [
  { name: "Socket.IO", type: "Backend", prof: "1" },
  { name: "CSS", type: "Frontend", prof: "2" },
  { name: "SprigBoot", type: "Backend", prof: "2" },
  { name: "Redux", type: "Frontend", prof: "1" },
];

const LINE_4 = [
  { name: "Java", type: "Language", prof: "1" },
  { name: "Angular", type: "Frontend", prof: "3" },
  { name: "SQL/NoSQL", type: "Backend", prof: "3" },
  { name: "HTML", type: "Frontend", prof: "3" },
];

const LINE_5 = [
  { name: "Python", type: "Language", prof: "2" },
  { name: "GraphQL", type: "Backend", prof: "2" },
  { name: "Jest", type: "Tools", prof: "3" },
  { name : "Kafka", type: "Backend", prof: "1"}
];

const LINE_6 = [
  { name: "Redis", type: "Backend", prof: "1" },
  { name: "Docker", type: "Tools", prof: "1" },
  { name: "Webpack", type: "Frontend", prof: "2" },
  { name: "GCP", type: "Tools", prof: "2" },
];

export const LINES = [LINE_1, LINE_2, LINE_3, LINE_4, LINE_5, LINE_6];
